import { render, staticRenderFns } from "./Legajos.vue?vue&type=template&id=2cc17686"
import script from "./Legajos.vue?vue&type=script&lang=js"
export * from "./Legajos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cc17686')) {
      api.createRecord('2cc17686', component.options)
    } else {
      api.reload('2cc17686', component.options)
    }
    module.hot.accept("./Legajos.vue?vue&type=template&id=2cc17686", function () {
      api.rerender('2cc17686', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Legajos/Legajos.vue"
export default component.exports